<template>
  <div id="app">
    <nav-bar />
    <router-view/>
    <edr-footer />
  </div>
</template>

<style>
@import url(https://fonts.googleapis.com/css?family=Jura:400,700|Rubik:400,700|Share+Tech+Mono:400);
html {
  background: #000000;
  font-family: 'Jura', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
}

body {
  font-size: 0.9em;
}

h1, h2, h3, h4 {
  font-family:'Rubik', 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  color: #ff7100;
}

.home {
  text-align: center;
}

a {
  color: #00b3f7;
}

code {
  background-color: #2F3136;
  color: #C4C4C4;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-family: 'Share Tech Mono', 'Lucida Console', Monaco, monospace;
  font-weight: 400;
  font-size: 0.9em;

}

hr {
  border-color: #833a01;
}
footer {
  color: #aaaaaa;
  font-size: 0.8em;
}
footer a {
  color: #eeeeee;
}

@media(min-width: 768px) {
  .container {
    max-width: 750px;
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>

<script>
import NavBar from './components/NavBar'
import EdrFooter from './components/EdrFooter'
export default {
  name: 'App',
  components: {
    NavBar: NavBar,
    EdrFooter: EdrFooter
  }
}
</script>
